exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-templates-basic-route-innards-jsx": () => import("./../../../src/templates/basic-route-innards.jsx" /* webpackChunkName: "component---src-templates-basic-route-innards-jsx" */)
}

